var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wt-table',{class:_vm.classes,attrs:{"list":_vm.data,"labels":_vm.labels}})}
var staticRenderFns = []

export { render, staticRenderFns }